import { track } from "@amplitude/analytics-react-native";
import { View } from "react-native";
import { RecapScreenFragmentFragment } from "src/api/graphql/__generated__/graphql";
import useMountEffect from "src/hooks/useMountEffect";
import RecapImageContent from "./components/RecapImageContent";
import RecapVideoContent from "./components/RecapVideoContent";
import { RecapScreenContentGenericProps } from "./types";

const RecapScreenContent = ({
	screen,
	contentAreaWidth,
	contentAreaHeight,
	onSelectionChange,
}: { screen: RecapScreenFragmentFragment } & RecapScreenContentGenericProps) => {
	const props = {
		contentAreaWidth,
		contentAreaHeight,
		onSelectionChange,
		trackingIdentifier: screen.trackingIdentifier ?? undefined,
	};
	useMountEffect(() => {
		track("recap_screenRender", {
			trackingIdentifier: screen.trackingIdentifier,
		});
	}, []);
	const renderContent = () => {
		if (screen.image) {
			return <RecapImageContent image={screen.image} {...props} />;
		}
		if (screen.video) {
			return <RecapVideoContent video={screen.video} {...props} />;
		}
		return null;
	};
	return (
		<View
			style={{
				width: contentAreaWidth,
				height: contentAreaHeight,
			}}
		>
			{renderContent()}
		</View>
	);
};
export default RecapScreenContent;
